import React from 'react';

import TextField from 'material-ui/TextField';
import { FormHelperText } from 'material-ui/Form';

const errorText = {
    display : 'flex',
    justifyContent : 'center',
    color : 'red'
};

const renderTextAreaWithDiv = ({ input, label, className, divClassName, password, disabled, rows, rowsMax, meta: { touched, error }, ...custom }) => (
    <div className={divClassName}>
        <TextField
            label={label}
            error={(touched && error && error !== '')}
            multiline
            rows={rows}
            rowsMax={rowsMax}
            disabled={disabled}
            className={className}
            {...input}
            {...custom}
        />
        {
            touched && error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </div>
);

export default renderTextAreaWithDiv;


// WEBPACK FOOTER //
// ./src/helpers/RenderTextAreaWithDiv.js